import styles from './CallBackLater.module.scss';
import { Button, DatePicker, Popup, Textbox } from 'components/generic';
import { useContext, useState, useEffect } from 'react';
import OverviewContext from 'store/overview-context';
import moment from 'moment';

const CallBackLater = props => {
	const overviewContext = useContext(OverviewContext);
	const [showTimeslots, setShowTimeslots] = useState(false);
	const [editState, setEditState] = useState(false);
	const [timeSlots, setTimeSlots] = useState(null);

	const getLang = key => {
		return overviewContext?.langObj?.content?.[key] || '';
	};

	// setting the local state for timeslots
	useState(() => {
		const data = overviewContext?.overviewData?.callbackLater?.at()?.ah_details;
		data && setTimeSlots({ from: data?.cbl_startTime, to: data?.cbl_endTime });
	}, [overviewContext?.overviewData?.callbackLater]);

	// setting callbackLater date
	const setData = (e, key) => {
		overviewContext?.setCallbackLaterObj(prevState => ({ ...prevState, [key]: e }));
	};

	// setting timeslots for callbackLater
	const selectTimeSlot = e => {
		setTimeSlots(e);
		setShowTimeslots(false);
		overviewContext?.setCallbackLaterObj(prevState => ({ ...prevState, cbl_startTime: e?.from, cbl_endTime: e?.to }));
	};

	// timeslots popup
	const timeSlotData = (
		<ul className={styles.timeslots__container}>
			{overviewContext?.overviewData?.wf_linkConfiguration?.callbackLaterConfiguration?.timeslots?.map((el, i) => (
				<li
					key={i}
					className={`${timeSlots === el && styles['is-active']}`}
					onClick={() => {
						editState && selectTimeSlot(el);
					}}
				>{`${el?.from} - ${el?.to}`}</li>
			))}
		</ul>
	);

	// selected date display
	const selectedSlots = (
		<>
			{overviewContext?.callbackLaterObj?.cbl_date && timeSlots && (
				<div className={styles.container__display}>
					<div className={styles.container__date}>
						<h3>{getLang('RECEIVE_CALL')}</h3>
						<span>{moment(overviewContext?.callbackLaterObj?.cbl_date).format('dddd Do MMMM, YYYY')}</span>
					</div>
					<div className={styles.container__time}>
						<h3>{getLang('TIME')}</h3>
						<span>{`${timeSlots?.from} - ${timeSlots?.to}`}</span>
					</div>
				</div>
			)}
		</>
	);

	// submit callback api call
	const submitCallback = async () => {
		props.onSubmitCallback();
	};

	useEffect(() => {
		setEditState(overviewContext?.overviewData?.wf_linkConfiguration?.callbackLaterConfiguration?.allowEdit ? true : !overviewContext?.overviewData?.callbackLater?.length);
	}, [overviewContext?.overviewData]);

	// form elements
	const formElements = (
		<>
			<div className={styles.row}>
				<div className={styles['col-6']}>
					<DatePicker isDisabled={!editState} value={overviewContext?.callbackLaterObj?.cbl_date} minDate={new Date()} onChange={e => setData(e, 'cbl_date')} />
				</div>
				<div className={styles['col-6']}>
					<Button
						transparent
						full
						disabled={!editState}
						left
						label={timeSlots ? `${timeSlots?.from || timeSlots?.cbl_startTime} - ${timeSlots?.to || timeSlots?.cbl_endTime}` : getLang('TIME_SLOTS')}
						height='45px'
						placeholderColor='#ccc'
						onSubmit={() => setShowTimeslots(true)}
					/>
				</div>
			</div>
			{selectedSlots}
		</>
	);

	return (
		<>
			<div className={styles.container}>
				<h4>{getLang('WHEN_GIVE_CALL')}</h4>
				{formElements}
				{overviewContext?.overviewData?.wf_linkConfiguration?.callbackLaterConfiguration?.captureReason && (
					<Textbox
						placeholder={getLang('EX_REASON_CALLBACK')}
						infoContent={getLang('INFO_REASON_CALLBACK')}
						disabled={!editState}
						value={overviewContext?.callbackLaterObj?.cbl_reason}
						maxlength={overviewContext?.overviewData?.wf_linkConfiguration?.callbackLaterConfiguration?.maximumCharLimit || 255}
						label={getLang('REASON_CALLBACK')}
						onChange={e => setData(e?.target?.value, 'cbl_reason')}
					/>
				)}
				{editState && <Button disabled={!overviewContext?.callbackLaterObj?.cbl_date || !timeSlots || !editState} primary full label={getLang('REQUEST_CALLBACK')} onSubmit={submitCallback} />}
			</div>
			<Popup popupState={showTimeslots} onClose={setShowTimeslots}>
				<div className={styles.timeslots}>
					<h2>{getLang('CHOOSE_TIMESLOT')}</h2>
					<div className={`${styles['timeslots--scroll']} scroll-bar`}>{timeSlotData}</div>
				</div>
			</Popup>
		</>
	);
};

export default CallBackLater;
